module.exports = __webpack_public_path__ + "static/media/NumStudentInGroup.8f95c47d.svg";